const electionNight = {
  en: {
    electionNightPage: {
      title: "Election Night Dashboard",
      subtitle: "{{label}} Elections - {{description}}",
      electionTypePlaceholder: "Election Type",
      live: "LIVE",
      paused: "Paused",
      refresh: "Refresh",
      updated: "Updated: {{time}}",
      shareTitle: "EReMS Cameroon - {{label}} Election Night",
      shareText: "🗳️ LIVE: {{label}} Election Results! Follow on EReMS Cameroon.",
      ofTotal: "of {{total}}",
      coverage: "Coverage",
      totalVotes: "Total Votes",
      validVotes: "Valid Votes",
      seatsDecided: "Seats Decided",
      of70: "of 70",
      rejectedVotes: "Rejected Votes",
      descPresidential: "Vote totals per candidate from reported stations",
      descParty: "Results breakdown by party",
      noResults: "No results yet",
      noResultsHint: "Results will appear as they are approved",
      basedOn: "Based on {{count}} {{unit}}",
      lead: "Lead",
      votes: "Votes",
      councils: "Councils",
      seats: "Seats",
      noLeader: "No leader yet",
      resultsPending: "Results pending",
      breakdownPresidential: "10 Regions • 58 Divisions Breakdown",
      breakdownParliamentary: "10 Regions • 180 Constituencies Breakdown",
      breakdownSenatorial: "Regional Results (7 seats per region)",
      breakdownCouncil: "Council Results by Region",
      ofDivisions: "of {{count}} divisions",
      ofConstituencies: "of {{count}} constituencies",
      sevenSeats: "7 seats",
      pending: "Pending",
      councilsDecided: "councils decided",
      awaitingResults: "awaiting results",
      specialRegions: "Special Regions Status",
      specialRegionsDesc: "Regional elections apply only to North-West and South-West",
      regionSuffix: "{{region}} Region",
      stationsReported: "Stations Reported:",
      validVotesColon: "Valid Votes:",
      types: {
        presidential: {
          label: "Presidential",
          description: "58 Divisions • 10 Regions • Nationwide",
          reportedLabel: "Divisions Reported",
          resultLabel: "Candidate Results",
          winnerLabel: "Projected Winner"
        },
        parliamentary: {
          label: "Parliamentary",
          description: "180 Constituencies • 10 Regions",
          reportedLabel: "Constituencies Reported",
          resultLabel: "Party Results",
          winnerLabel: "Leading Party"
        },
        senatorial: {
          label: "Senatorial",
          description: "10 Regions • 70 Seats (7 per region)",
          reportedLabel: "Regions Decided",
          resultLabel: "Party Results",
          winnerLabel: "Leading Party"
        },
        regional: {
          label: "Regional",
          description: "North-West & South-West Only",
          reportedLabel: "Regions Reported",
          resultLabel: "Party Results",
          winnerLabel: "Leading Party"
        },
        council: {
          label: "Council",
          description: "360 Councils • Nationwide",
          reportedLabel: "Councils Decided",
          resultLabel: "Party Results",
          winnerLabel: "Leading Party"
        }
      },
      regions: {
        "Adamawa": "Adamawa",
        "Centre": "Centre",
        "East": "East",
        "Far North": "Far North",
        "Littoral": "Littoral",
        "North": "North",
        "North-West": "North-West",
        "South": "South",
        "South-West": "South-West",
        "West": "West"
      }
    }
  },
  fr: {
    electionNightPage: {
      title: "Tableau de bord de la nuit électorale",
      subtitle: "Élections {{label}} - {{description}}",
      electionTypePlaceholder: "Type d'élection",
      live: "EN DIRECT",
      paused: "En pause",
      refresh: "Actualiser",
      updated: "Mis à jour : {{time}}",
      shareTitle: "EReMS Cameroon - Nuit électorale {{label}}",
      shareText: "🗳️ EN DIRECT : résultats des élections {{label}} ! Suivez-les sur EReMS Cameroon.",
      ofTotal: "sur {{total}}",
      coverage: "Couverture",
      totalVotes: "Total des votes",
      validVotes: "Votes valides",
      seatsDecided: "Sièges attribués",
      of70: "sur 70",
      rejectedVotes: "Votes rejetés",
      descPresidential: "Total des voix par candidat à partir des bureaux de vote ayant transmis",
      descParty: "Répartition des résultats par parti",
      noResults: "Aucun résultat pour le moment",
      noResultsHint: "Les résultats apparaîtront dès leur approbation",
      basedOn: "Basé sur {{count}} {{unit}}",
      lead: "Avance",
      votes: "Voix",
      councils: "Communes",
      seats: "Sièges",
      noLeader: "Aucun leader pour le moment",
      resultsPending: "Résultats en attente",
      breakdownPresidential: "10 régions • Détail des 58 départements",
      breakdownParliamentary: "10 régions • Détail des 180 circonscriptions",
      breakdownSenatorial: "Résultats régionaux (7 sièges par région)",
      breakdownCouncil: "Résultats des communes par région",
      ofDivisions: "sur {{count}} départements",
      ofConstituencies: "sur {{count}} circonscriptions",
      sevenSeats: "7 sièges",
      pending: "En attente",
      councilsDecided: "communes attribuées",
      awaitingResults: "en attente de résultats",
      specialRegions: "Statut des régions spéciales",
      specialRegionsDesc: "Les élections régionales ne concernent que le Nord-Ouest et le Sud-Ouest",
      regionSuffix: "Région du {{region}}",
      stationsReported: "Bureaux de vote ayant transmis :",
      validVotesColon: "Votes valides :",
      types: {
        presidential: {
          label: "Présidentielle",
          description: "58 départements • 10 régions • National",
          reportedLabel: "Départements ayant transmis",
          resultLabel: "Résultats des candidats",
          winnerLabel: "Vainqueur projeté"
        },
        parliamentary: {
          label: "Législative",
          description: "180 circonscriptions • 10 régions",
          reportedLabel: "Circonscriptions ayant transmis",
          resultLabel: "Résultats des partis",
          winnerLabel: "Parti en tête"
        },
        senatorial: {
          label: "Sénatoriale",
          description: "10 régions • 70 sièges (7 par région)",
          reportedLabel: "Régions attribuées",
          resultLabel: "Résultats des partis",
          winnerLabel: "Parti en tête"
        },
        regional: {
          label: "Régionale",
          description: "Nord-Ouest et Sud-Ouest uniquement",
          reportedLabel: "Régions ayant transmis",
          resultLabel: "Résultats des partis",
          winnerLabel: "Parti en tête"
        },
        council: {
          label: "Municipale",
          description: "360 communes • National",
          reportedLabel: "Communes attribuées",
          resultLabel: "Résultats des partis",
          winnerLabel: "Parti en tête"
        }
      },
      regions: {
        "Adamawa": "Adamaoua",
        "Centre": "Centre",
        "East": "Est",
        "Far North": "Extrême-Nord",
        "Littoral": "Littoral",
        "North": "Nord",
        "North-West": "Nord-Ouest",
        "South": "Sud",
        "South-West": "Sud-Ouest",
        "West": "Ouest"
      }
    }
  }
};

export default electionNight;
